import { Box, styled, Tooltip } from '@mui/material';
import { Handle, type Node, type NodeProps, Position } from '@xyflow/react';
import { NodeHeader } from './node-header';
import type { WaitNodeData } from '../../../components/workflow-editor/mappers/map-canvas-content.types';

export const WaitNode = ({ data }: NodeProps<Node<WaitNodeData, 'wait'>>) => {
  const pct = data?.percentage;
  const headerHelperText =
    'Delay workflow execution until a specified percentage of time remains between shift creation and start time. For example, with 90% and a shift created at 10:20 starting at 10:30, execution continues at 10:21 when 90% of the time remains.';

  return (
    <Tooltip placement="top" title={headerHelperText}>
      <NodeWrapper className="nopan">
        <NodeHeader nodeTitle="Timed Delay" />
        <Value>
          {pct === undefined || pct === null ? (
            'Not configured'
          ) : (
            <>
              Execution delayed until <Highlight>{pct}%</Highlight> of time remains between shift
              creation and start time.
            </>
          )}
        </Value>

        <Handle type="target" position={Position.Left} />
        <Handle type="source" position={Position.Right} />
      </NodeWrapper>
    </Tooltip>
  );
};

const NodeWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.lwWhite[100],
  border: `1px solid ${theme.palette.lwSecondaryAccentLight[20]}`,
  borderRadius: theme.spacing(3),
  padding: theme.spacing(2),
  width: 250,
  fontWeight: 700,
  textAlign: 'center',
}));

const Value = styled(Box)({
  fontWeight: 500,
  fontSize: '10px',
  wordBreak: 'break-word',
  textAlign: 'justify',
});

const Highlight = styled('span')(({ theme }) => ({
  fontWeight: 800,
  color: theme.palette.lwBlack[100],
  fontSize: theme.spacing(3),
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(0.5),
  borderRadius: theme.spacing(2),
}));
